import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
  KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import CustomDateRangePicker, { dateFilter, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';
import MenuActionDropdown from 'general/components/Others/MenuActionDropdown';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

ChargeStationLogView.propTypes = {
  chargeStationId: PropTypes.string,
  isAdminAgency: PropTypes.bool,
};

function ChargeStationLogView(props) {
  // MARK: ---- PROPERTIES ----
  const { chargeStationId, isAdminAgency } = props;
  const [filter, setFilter] = useState({
    q: '',
    level: '',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    dateFilter: dateFilter.baMuoiNgayGanNhat,
    from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
  });
  const [items, setItems] = useState([]);
  useEffect(() => {
    ChargeHelper.API.getMessageLogList(chargeStationId, filter).then((response) => {
      if (response) {
        setItems(response.messages);
        setTotal(response.total);
      }
    });
  }, [chargeStationId, filter]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const columns = useMemo(() => {
    return [
      {
        id: 'SYSTEM_LOG_CODE',
        name: UIHelper.buildTableColumn('Mã thông báo'),
        selector: (row) => row.messageId,
        width: '140px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'TITLE',
        name: UIHelper.buildTableColumn('Tiêu đề'),
        selector: (row) => row?.title,
        minWidth: '320px',
        style: tableStyle.columns.normal,
      },
      // {
      //   id: 'LEVEL',
      //   name: UIHelper.buildTableColumn('Loại thông báo'),
      //   selector: (row) => {
      //     return (
      //       <KTLabel
      //         text={ChargeHelper.Utils.getMessageLogTypeName(row?.level)}
      //         isInline={true}
      //         size={KTLabelSize.medium}
      //         additionalClassName={`label-light-${ChargeHelper.Utils.getMessageLogTypeColor(
      //           row?.level
      //         )}`}
      //       />
      //     );
      //   },
      //   width: '160px',
      // },
      {
        id: 'TIME',
        name: UIHelper.buildTableColumn('Thời gian'),
        selector: (row) => Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY - HH:mm'),
        width: '150px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn('Thao tác'),
        maxWidth: '90px',
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        center: true,
        cell: (row) => {
          return (
            <MenuActionDropdown
              menuAction={[
                {
                  iconElement: (
                    <i
                      className="fa-regular fa-eye"
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: 'Xem chi tiết',
                  click: () => {
                    if (!isAdminAgency) {
                      Utils.openInNewTab(`${AppRoute.pointList}/${row?.pointId}`)
                    } else {
                      Utils.openInNewTab(`${AppRoute.stationList}/${chargeStationId}/point/${row?.pointId}`)
                    }
                  },
                  show: true,
                },
              ]}
            />
          )
        },
      },
    ];
  }, []);

  return (
    <div>
      {UIHelper.buildCard(
        <div className="pb-4">
          {/* header */}
          <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between">
            <div className="d-flex flex-column">
              <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                Thông báo vận hành trạm
              </span>
              <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                Tổng:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                  {Utils.formatNumber(total)} thông báo
                </span>
              </span>
            </div>
          </div>

          {/* table */}
          <div className="">
            {/* filter */}
            <div className="row m-0 p-0 px-2">
              {/* tim kiem */}
              <div className="col-xl-3 col-md-4 col-6 mb-4 px-2">
                {UIHelper.buildFormLabel('Tìm kiếm')}
                <KTFormSearch
                  name="search"
                  placeholder="Tìm kiếm theo tiêu đề"
                  value={filter.q}
                  onSubmit={(text) => {
                    setFilter({ ...filter, q: text, page: 0 });
                  }}
                />
              </div>
              {/* loc theo thoi gian */}
              <div className="col-xl-3 col-md-4 col-6 mb-4 px-2">
                {UIHelper.buildFormLabel('Thời gian')}
                <CustomDateRangePicker
                  alignRight={true}
                  toggleFontWeight="400"
                  toggleElementBorderRadius={5}
                  initialValue={filter?.dateFilter}
                  onPressSave={(selectedValue, startDate, endDate) => {
                    setFilter({
                      ...filter,
                      dateFilter: selectedValue,
                      from: startDate,
                      to: endDate,
                      page: 0,
                    });
                  }}
                  hasResetButton={true}
                />
              </div>
            </div>

            <div className="px-4">
              <KTTable
                columns={columns}
                items={items}
                selectableRows={false}
                striped={false}
                compactGrid={false}
                hasActionColumn={true}
                onClickedRow={(row) => { }}
                onSelectedRowsChanged={(rows) => { }}
                onDoubleClickedRow={(row) => { }}
                noDataComponent={UIHelper.buildEmptyNoData(
                  'Không có thông báo nào từ trạm sạc này.'
                )}
              />

              {/* phan trang */}
              <div className="mt-2">
                <KTPagination
                  currentPage={filter.page + 1}
                  rowCount={total}
                  rowsPerPage={filter.limit}
                  currentItemInPageCount={items?.length}
                  onChangePage={(newPage) => {
                    const iNewPage = parseInt(newPage);
                    setFilter({
                      ...filter,
                      page: iNewPage - 1,
                    });
                  }}
                  onChangeRowsPerPage={(newRowsPerPage) => {
                    const iNewRowsPerPage = parseInt(newRowsPerPage);
                    setFilter({
                      ...filter,
                      limit: iNewRowsPerPage,
                      page: 0,
                    });
                  }}
                  loading={false}
                  color={KTPaginationColor.success}
                  appendText="thông báo"
                />
              </div>
            </div>
          </div>
        </div>,
        false
      )}
    </div>
  );
}

export default ChargeStationLogView;
